import React from 'react';
import {
  Header,
  SubHeader,
  SiteLogo,
  TradingBlockLink,
  ExternalLink,
  SiteName,
  Section,
  FooterTeaser,
} from '@tradingblock/components';
import { config as Config } from '../clientConfig';
import { Link } from 'react-router-dom';
import { getStaticPath } from '../utils';

export const VTHomePage: React.FC = () => {
  const grp = Config.siteGrp;
  const group: 'mb' | 'tb' = grp === 'mb' ? 'mb' : 'tb';
  const isVirtual = true;
  const siteParam = grp ? `?grp=${grp}` : '';

  const siteName = group === 'mb' ? 'MoneyBlock' : 'TradingBlock';

  return (
    <div className="env-virtual apiserver-app">
      <Header>
        <SubHeader>
          <SiteLogo siteGroup={grp} />
          <nav className="nav-utilities">
            <ul>
              <li>
                {isVirtual ? (
                  <ExternalLink href={Config.goToLiveUrl + siteParam}>Go to live trading account</ExternalLink>
                ) : (
                  <TradingBlockLink siteGroup={group} origin={group} to="LegacySiteHomeUrl">
                    &uarr; Go to <SiteName siteGroup={group} /> Legacy
                  </TradingBlockLink>
                )}
              </li>
              <li>
                <TradingBlockLink siteGroup={group} origin={group} to="CustomerServiceUrl">
                  Contact us
                </TradingBlockLink>
              </li>
            </ul>
          </nav>
        </SubHeader>
      </Header>
      <main className="vt-home-page">
        <Section className="home-title-section">
          <div className="home-title-container container-fluid">
            <div className="row">
              <div className="col-12 col-lg-6 px-3 px-lg-4">
                <h1>Build Trading Skills</h1>
                <h1>with Virtual Trader</h1>
                <div className="subtitle">
                  <p>
                    Open your free {siteName} Virtual Trading account in minutes and start practicing with $500,000 in
                    simulated funds.
                  </p>
                </div>
                <ul>
                  <li>Test options strategies in a full-featured environment before putting money at risk</li>
                  <li>Experiment with charting tools and technical indicators</li>
                  <li>Explore order types and trade management features</li>
                </ul>
                <div className="button-container">
                  <div className="row-auto px-0">
                    <ExternalLink href={`${Config.virtual.applicationUrl}${siteParam}`}>
                      <button className="btn btn-primary w-100 virtual-trading-btn">
                        Register for Virtual Trading
                      </button>
                    </ExternalLink>
                  </div>
                  <div className="row-auto px-0">
                    <Link to={`/login${siteParam}`}>
                      <button className="btn btn-outline-primary w-100">Login to Virtual Trading</button>
                    </Link>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-12">
                    <p>
                      Ready for a live trading account?{' '}
                      <a href={Config.virtual.liveApplicationUrl + siteParam}>Click here to get started!</a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-6 px-3 px-lg-4 mt-4 mt-lg-0">
                <img src={getStaticPath('/images/vt-home-page.png')} alt="Virtual Trading Account" className="img-fluid" />
              </div>
            </div>
          </div>
        </Section>
      </main>
      <footer className="footer">
        <div className="content">
          <FooterTeaser siteGroup={group} />
        </div>
      </footer>
    </div>
  );
};
